// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useCallback, useState } from 'react';

import { useResizeObserver } from '@amzn/awsui-component-toolkit/internal';

/**
 * Conditional resize observer for border box height used in charts.
 */
export function useHeightMeasure(
  getMeasure: () => null | HTMLElement | SVGElement,
  skip = false,
  deps: React.DependencyList = []
) {
  const [measuredHeight, setHeight] = useState(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableGetMeasure = useCallback(getMeasure, [...deps, skip]);
  useResizeObserver(stableGetMeasure, entry => !skip && setHeight(entry.borderBoxHeight));
  return !skip ? measuredHeight : undefined;
}



// WEBPACK FOOTER //
// /local/home/vibhorbh/src/internal/hooks/container-queries/use-height-measure.ts